import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { isDevelopment } from '../utils/helpers';

const { PUBLIC_URL } = process.env;

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'nl',
    debug: isDevelopment,
    backend: {
      loadPath: `${PUBLIC_URL || ''}/locales/%lng%/%ns%.json`, // Necessary to change interpolation prefix
    },
    interpolation: {
      prefix: '%',
      suffix: '%',
      escapeValue: false,
    },
  });

export const TRANSLATED_ROUTES = {
  ORDER: ['order', 'bestelling', 'bestellung', 'commande'],
  MEMBER: ['lid', 'member'],
} as const;

export default i18n;
